var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showOffersAnimationSection
    ? _c("section", { staticClass: "container-fluid pt-1 pt-md-2" }, [
        _c(
          "div",
          { staticClass: "row mb-1 mb-lg-2" },
          [
            _c("div", { staticClass: "col-12" }, [
              _c("h2", [_vm._v(_vm._s(_vm.offersAnimation.title))]),
            ]),
            _vm._v(" "),
            _vm._l(
              _vm.offersAnimation.selectionsTileList,
              function (selectionTile, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "col-12 col-lg-6 pb-1 pb-lg-2" },
                  [
                    _c(
                      "div",
                      { staticClass: "bg-dark h-100" },
                      [
                        selectionTile.link
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "ob1-link no-decoration",
                                  attrs: {
                                    target: "_blank",
                                    href: selectionTile.link,
                                    "data-oevent-category":
                                      selectionTile.tms.category,
                                    "data-oevent-action":
                                      selectionTile.tms.action,
                                    "data-oevent-label":
                                      selectionTile.tms.label,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "h-100 d-flex align-items-center",
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img-avantages",
                                        attrs: {
                                          loading: "lazy",
                                          src: selectionTile.img.src,
                                          alt: selectionTile.img.alt,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "p-1 text-white" },
                                        [
                                          _c("p", {
                                            staticClass:
                                              "lead fw-bold py-0 mb-0",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                selectionTile.desc
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "h-100 d-flex align-items-center",
                                },
                                [
                                  _c("img", {
                                    staticClass: "img-avantages",
                                    attrs: {
                                      loading: "lazy",
                                      src: selectionTile.img.src,
                                      alt: selectionTile.img.alt,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-1 text-white" }, [
                                    _c("p", {
                                      staticClass: "lead fw-bold py-0 mb-0",
                                      domProps: {
                                        innerHTML: _vm._s(selectionTile.desc),
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                            ],
                      ],
                      2
                    ),
                  ]
                )
              }
            ),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }